import React, { useContext } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';

import { debounce } from 'lodash';

import FilterCtx from '../../../../context/filterContext/filterCtx';

import { IDocNameFilter } from '../../types/IDocNameFilter';

import '../filters.scss';
import './docNameFilter.scss';

const DocNameFilter: React.FC<IDocNameFilter> = ({ table, className }) => {
  const { t } = useTranslate();
  const filterCtx: any = useContext(FilterCtx);

  const handleInputChange = debounce((event: any) => {
    if (table === 'documents') {
      filterCtx.setDocName(event.target.value);
    } else {
      filterCtx.setDocNameActivity(event.target.value);
    }
  }, 500);

  return (
    <div className={`name-filter-wrapper pointer ${className ? className : ''}`}>
      <input
        className="ci-input"
        type="search"
        placeholder={t('FILTERS.SEARCH')}
        onChange={handleInputChange}
        defaultValue={table === 'documents' ? filterCtx.docName : filterCtx.docNameActivity}
      />
    </div>
  );
};

export default DocNameFilter;
